module.exports = __webpack_public_path__ + "img/machine-20.9c3f5609.svg";